import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import * as s from "./index.module.scss";
import Home from "../../../images/Breadcrumb/breadcrumb-home.svg";

const convertBreadcrumb = (string) => {
  const replacements = {
    "watch-buyers-nyc": "Luxury watches",
    "sell-diamonds-nyc": "Diamonds",
    "collateral-loans": "Collateral loan",
    "jewelry-buyers": "Jewelry",
    "gold-buyers-nyc": "Sell your gold",
    "gold-coin-buyers-nyc": "Sell your gold coins",
    "platinum-buyers": "Sell your platinum",
    "silver-buyers": "Sell your silver",
    "bell-ross-watch-buyers": "Bell & ross watch buyers",
    "designer-bag-buyers": "Sell your bag",
    "bridge-loans": "Bridge Loans",
  };

  if (replacements[string]) {
    return replacements[string];
  }

  return string
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
    .replace(/-/g, " ");
};

const Breadcrumbs = () => {
  const router = useRouter();
  const [breadcrumbs, setBreadcrumbs] = useState(null);

  useEffect(() => {
    if (router) {
      // const linkPath = router.asPath.split("/");
      const linkPath = router.asPath.split("?")[0].split("/");
      linkPath.shift();

      const pathArray = linkPath.map((path, i) => {
        return {
          breadcrumb: path,
          href: "/" + linkPath.slice(0, i + 1).join("/"),
        };
      });

      setBreadcrumbs(pathArray);
    }
  }, [router]);

  if (!breadcrumbs) {
    return null;
  }

  return (
    <div className={s.breadcrumbs}>
      <ol className={s.breadcrumb_container}>
        <li>
          <Link href="/" aria-label={"Home page"}>
            <img
              loading="lazy"
              src={Home.src}
              alt="home-icon"
              width="32px"
              height="32px"
            />
          </Link>
        </li>
        {breadcrumbs.map((breadcrumb, idx) => {
          const isLast = idx === breadcrumbs.length - 1;
          const startsWithSell = breadcrumb.breadcrumb
            .toLowerCase()
            .startsWith("sell");

          const firstIsWhatWeBuy = breadcrumbs[0]?.breadcrumb === "what-we-buy";
          const secondIsWatchBuyers =
            breadcrumbs[1]?.breadcrumb === "watch-buyers-nyc";

          const shouldCapitalize =
            isLast && startsWithSell && firstIsWhatWeBuy && secondIsWatchBuyers;

          return (
            <li key={idx}>
              <Link
                href={breadcrumb.href}
                className={`
          ${shouldCapitalize ? s.capitalize : ""}
        `}
                style={{
                  color: breadcrumbs.length - 1 !== idx ? "#667085" : "#000000",
                }}
              >
                {convertBreadcrumb(breadcrumb.breadcrumb)}
              </Link>
            </li>
          );
        })}
      </ol>
    </div>
  );
};

export default Breadcrumbs;
